import { get, post } from '@/api/server'

// 自动登录
export function apiUseTokenLogin(data) {
  return post({
    url: '/webcad/autologin',
    data
  })
}

// 账号&密码登录
export function apiAccountPwdLogin(data) {
  return post({
    url: '/webcad/loginaccount',
    data
  })
}

// 手机验证码登录
export function apiPhoneCodeLogin(data) {
  return post({
    url: '/webcad/loginsendmsg',
    data
  })
}

// 微信登录获取二维码
export function apiWeChatLoginGetCode(data) {
  return get({
    url: '/wechat/get_wxlogin_code',
    data
  })
}

// 微信登录获取二维码状态
export function apiGetWxCodeStatus(data) {
  return get({
    url: '/wechat/get_wxlogin_status',
    data
  })
}

// 微信登录扫码成功后回调
export function apiScanWxCodeBack(data) {
  return post({
    url: '/webcad/pcnewloginweixin',
    data
  })
}

// 微信绑定手机号
export function apiWxBindTelphone(data) {
  return post({
    url: '/webcad/wxbindphone',
    data
  })
}

// 注册
export function apiToRegister(data) {
  return post({
    url: '/webcad/rgister',
    data
  })
}

/* --- 新 --- */
// 获取微信小程序登录码
export function apiGetAppletCode(data) {
  return post({
    url: '/webcad/Getwxucodelogin',
    data
  })
}

// 微信小程序登录获取二维码状态
export function apiGetAppletStatus(data) {
  return post({
    url: '/webcad/getWxloginstatu',
    data
  })
}

// 获取参数appid
export function apiGetSetInfo(data) {
  return post({
    url: '/webcad/Getsetinfo',
    data
  })
}

export function apiFastLogin(data) {
  return post({
    url: '/webcad/fastlogin',
    data
  })
}
